export { BottomNavigationBar } from "./BottomNavigationBar";
export type { BottomNavigationVariant } from "./types";
